import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h-4v8h4","key":"svg-0"}],["path",{"d":"M10 12h2.5","key":"svg-1"}]]

/**
 * IconLetterESmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLWUtc21hbGwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE0IDhoLTR2OGg0IiAvPgogIDxwYXRoIGQ9Ik0xMCAxMmgyLjUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/letter-e-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterESmall = createReactComponent('outline', 'letter-e-small', 'LetterESmall', __iconNode);

export default IconLetterESmall;